import { useMemo } from "react"
import { Observable } from "rxjs"

export const useEvent$ = <T>(name: string) => {

  return useMemo(() => {
    return new Observable<T>((observer) => {
      const handler = (e) => {
        observer.next(e)
        console.log(name, e)
      }
      document.addEventListener(name, handler);

      return () => {
        document.removeEventListener(name, handler)
      }
    })
  }, [])
}